import { render, staticRenderFns } from "./ChurnMerchants.vue?vue&type=template&id=0aed5302&scoped=true"
import script from "./ChurnMerchants.vue?vue&type=script&lang=ts"
export * from "./ChurnMerchants.vue?vue&type=script&lang=ts"
import style0 from "./ChurnMerchants.vue?vue&type=style&index=0&id=0aed5302&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed5302",
  null
  
)

export default component.exports